module.exports = __webpack_public_path__ + "img/lr.6656f943.svg";